import { NodeCategoryModel } from 'src/modules/network-configuration/models/node-data';
import {
  IConfigurationLldp,
  IConfigurationLldpInterface,
} from 'src/types/configuration';

export const configurationLldp = ({
  nodeId,
  nodeCategory,
}: {
  nodeId: string;
  nodeCategory: NodeCategoryModel;
}): IConfigurationLldp => {
  const defaultInterface: IConfigurationLldp = {
    interfaces: [],
    version: 1,
  };

  const defaultInterfaceItem: IConfigurationLldpInterface = {
    interface: 0,
    tx: true,
  };

  const interfaceItem: IConfigurationLldpInterface[] = [];
  if (!nodeCategory.ports) return defaultInterface;

  nodeCategory.ports.forEach((port) => {
    const { portIndexes } = nodeCategory;
    const portIndex = portIndexes[port.id] || 0;
    if (!portIndex) {
      throw new Error('Port index not found');
    }
    const interfaceItemData = {
      ...defaultInterfaceItem,
      interface: portIndex,
    };

    interfaceItem.push(interfaceItemData);
  });

  defaultInterface.interfaces = interfaceItem.sort(
    (a, b) => a.interface - b.interface,
  );

  return defaultInterface;
};
